
import { connect } from 'react-redux';
import MenuItemComponent from '../components/MenuItem';
import { playLive } from '../../aovivoBar/actions/MediaPlayerActions';

const mapDispatchToProps = (dispatch, ownProps) => ({
    ...ownProps,
    playLive: () => {
        dispatch(playLive());
    },
});

const MenuItemContainer = connect(
    null,
    mapDispatchToProps,
)(MenuItemComponent);

export default MenuItemContainer;
